// Mirrors the backend NexBase.Mdd.NotificationSeverity enum (values must stay in sync).
export enum NotificationSeverity {
  info = 1,
  success = 2,
  warning = 3,
  error = 4,
}
